import { render, staticRenderFns } from "./MyMenu.vue?vue&type=template&id=63513806&scoped=true"
import script from "./MyMenu.vue?vue&type=script&lang=js"
export * from "./MyMenu.vue?vue&type=script&lang=js"
import style0 from "./MyMenu.vue?vue&type=style&index=0&id=63513806&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63513806",
  null
  
)

export default component.exports